import { api, apiEndpoint } from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { ACCOUNT_SERVICE } from "../config/index.ts";
import {
  OAuthClient,
  OAuthRequest,
  OAuthRequestIdSchema,
} from "../models/index.ts";

export const oauthApi = api(
  { domain: API_DOMAIN, path: `${ACCOUNT_SERVICE.LABEL}/oauth/api` },
  {
    approveRequest: apiEndpoint({
      body: z.object(
        { id: OAuthRequestIdSchema },
        { id: "The id of the authorization request to approve" },
      ),
      response: z.object(
        { redirectUrl: z.url() },
        { redirectUrl: "The client's redirect URI, carrying the approval" },
      ),
    }),
    denyRequest: apiEndpoint({
      body: z.object(
        { id: OAuthRequestIdSchema },
        { id: "The id of the authorization request to deny" },
      ),
      response: z.object(
        { redirectUrl: z.url() },
        { redirectUrl: "The client's redirect URI, carrying the denial" },
      ),
    }),
    getRequest: apiEndpoint({
      body: z.object(
        { id: OAuthRequestIdSchema },
        { id: "The id of the authorization request" },
      ),
      response: z.object(
        { client: OAuthClient.schema, request: OAuthRequest.schema },
        {
          client: "The client requesting the authorization",
          request: "The authorization request",
        },
      ),
    }),
  },
);
